import sectionFaqCardCss from '../css-snippets/section-faq-card';

const html = `
<style>${sectionFaqCardCss}</style>
<div
  data-container="faq-grid-container-fluid-unique-id"
  data-id="unique-id"
  data-attribute="faq-grid-container-fluid"
  data-top-padding="true"
  data-bottom-padding="true"
  class="faq-grid-container-fluid"
  data-container-full-width="false"
>
  <div data-attribute="faq-grid-container" class="faq-grid-container container">
    <div data-attribute="title-faq-grid" class="title-faq-grid">
      <h2 style="text-align: center">
        <strong>Take a closer look at the GO S posture trainer</strong>
      </h2>
    </div>
    <div data-attribute="faq-grid-content" data-layout="left" class="faq-grid-content">
      <div data-attribute="card-info" class="card-info">
        <div class="card-info-inner">
          <div class="card-info-image">
            <img
              data-attribute="card-info-img"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0da17725511a331c64bd0.webp?w=1000"
              alt=""
            />
          </div>
          <div data-attribute="card-info-text" class="card-info-text">
            <h2 style="text-align: center"><strong>UPRIGHT GO S™</strong></h2>
            <p style="text-align: center">Light gray</p>
          </div>
        </div>
      </div>
      <div data-attribute="list-item" class="list-item" data-background-items="#F7F8F9">
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0da8051cc806f9d699e42.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
                Advanced biofeedback sensors
              </h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0da9c89cf357f05082acd.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
                Daily training intensity setups
              </h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0db446f1f925f131d9e19.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
                Auto App syncing
              </h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0db728a27638c9b07f69d.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
                Feedback plans
              </h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dac6e0c028fa67404c90.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
                Battery & Power
              </h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dbab8ea34a7f07144f74.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
                Auto Calibration
              </h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dbb563c26afe82182b3b.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
                Splash-proof
              </h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dbbd341f28eb68d75906.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">Device size</h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
        <div data-attribute="item-wapper" class="item-wapper">
          <div data-attribute="item-question" class="item-question">
            <div class="item-question-inner">
              <div class="item-question-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dbc533a71fe269fb365b.webp?w=50" alt="img" />
              </div>
              <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
                What’s included
              </h3>
            </div>
            <span data-attribute="icon-minus" style="display: none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span data-attribute="icon-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </span>
          </div>
          <div data-attribute="item-answer" class="item-answer">
            <div data-attribute="answer-content" class="answer-content">Content answer</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
